import { createAction } from "redux-actions"

import { REQUEST_ORDER, RECEIVE_ORDER, CLEAR_ORDER } from "./constants"

export const requestOrder = createAction(REQUEST_ORDER)
export const receiveOrder = createAction(RECEIVE_ORDER)

export const clearOrder = createAction(CLEAR_ORDER)
